export default __webpack_public_path__ + "static/About-us-giving-bdbae152bb7d664ecbfd8025619e2213.png";